import React, { useState } from "react";
import { ExportJobsPanel } from "./ExportJobsPanel";
import { ExportExecutionHistoryPanel } from "./ExportExecutionHistoryPanel";
import { useModalMotion } from "../../components/motion/useModalMotion";
import { ModalShell } from "../../components/motion/ModalShell";

// Internal-only entry point into the self-serve affiliate export system
// (DEV-2036), launched from the masquerade banner's support toolbelt in
// MainLayout (alongside "Change history"), not from the advertiser-facing
// UserMenu. Only rendered while a support user is masquerading as an
// advertiser, so it can never be reached directly by the advertiser
// themselves. Portal modal hosting the job list (ExportJobsPanel) with
// drill-down into a single job's execution history
// (ExportExecutionHistoryPanel) via a simple back button — mirrors the
// existing nested-panel pattern used elsewhere in this repo.
export function ExportsPanel({ onClose }) {
  const [historyJob, setHistoryJob] = useState(null);
  // A drill-down can open its own modal on top of this one (the mapping modal, the ledger,
  // re-run dates); useModalMotion sends Escape to that topmost one only.
  const motion = useModalMotion(onClose);
  const { requestClose } = motion;

  return (
    <ModalShell motion={motion} label="Affiliate Conversion Exports" maxWidth={900} panelStyle={{ overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "18px 24px", borderBottom: "1px solid #F0F0F0", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          {historyJob ? (
            <button type="button" onClick={() => setHistoryJob(null)} style={{ background: "none", border: "none", color: "#626262", fontSize: 13, cursor: "pointer" }}>← Back to jobs</button>
          ) : (
            <span style={{ fontWeight: 600, color: "#151515", fontSize: 16, fontFamily: "'Clash Display Variable','Clash Display',sans-serif" }}>Affiliate Conversion Exports</span>
          )}
          <button type="button" onClick={requestClose} aria-label="Close" style={{ background: "none", border: "none", color: "#626262", fontSize: 20, cursor: "pointer" }}>✕</button>
        </div>
        <div style={{ padding: 24, overflowY: "auto", flex: 1 }}>
          {historyJob ? (
            <ExportExecutionHistoryPanel job={historyJob} />
          ) : (
            <ExportJobsPanel onViewHistory={setHistoryJob} />
          )}
        </div>
    </ModalShell>
  );
}
